import React from 'react';
import Emoji from './../Partials/Emoji';

class Reactions extends React.Component {
    constructor(props) {
        super(props);

        this.cookieName = window.btoa(`post_reactions`);

        this.state = {
            choosenReaction: this.getReaction(),
            count: this.props.post.reactions,
            running: false,
            single: this.props.post.meta_data.single_reaction,
        }

        this.doReaction = this.doReaction.bind(this);
    }

    getReaction() {
        let reactions = this.getCookieReactions();
        return reactions[this.props.post.id] ?? false;
    }

    getCookieReactions() {
        let reactionsJSON = window.Cookie.get(this.cookieName);
        if (typeof reactionsJSON == 'undefined') {
            return false;
        }
        return JSON.parse(reactionsJSON);
    }

    doReaction(e) {
        const button = e.currentTarget;
        const clickedReaction = button.getAttribute('aria-label');

        let reactions = this.getCookieReactions() || {};

        // Stop if we are awaiting a call already
        if (this.state.running) {
            return;
        }

        // Set running state to avoid spam clicking
        this.setState({
            running: true,
        });

        // Temporarily changing value on clicked reaction (maybe find a better solution?)
        button.parentElement.querySelector('span').textContent = (reactions[this.props.post.id] !== clickedReaction) ? this.state.count[clickedReaction] + 1 : this.state.count[clickedReaction] - 1;

        if (reactions[this.props.post.id] == clickedReaction) {
            // Remove reaction
            delete reactions[this.props.post.id];
            this.updateReaction(false, clickedReaction);
        } else if (reactions[this.props.post.id]) {
            // Change reaction
            reactions[this.props.post.id] = clickedReaction;
            this.updateReaction(clickedReaction, this.state.choosenReaction);
        } else {
            // Add reaction
            reactions[this.props.post.id] = clickedReaction;
            this.updateReaction(clickedReaction, false);
        }

        this.setReactions(reactions, clickedReaction);
    }

    updateReaction(add, remove) {
        let data = {};
        data.post_id = this.props.post.id;

        if (add) {
            data.add_reaction = add;
        }
        if (remove) {
            data.remove_reaction = remove;
        }
        axios.post('/api/reaction/', data)
        .then((response) => {
            if (response.data.success) {
                this.setState({
                    count: response.data.reactions,
                });
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            this.setState({
                running: false,
            });
        });
    }

    setReactions(reactions, newReaction) {
        this.setState({
            choosenReaction: this.state.choosenReaction !== newReaction ? newReaction : false,
        });

        window.Cookie.set(this.cookieName, JSON.stringify(reactions), { expires: (365 * 10) });
    }

    render() {
        if (this.state.single == 1) {
            return (
                <div className={`reactions reactions--single ${this.props.className || ''}`}>
                    <div className={`reaction` + (this.state.choosenReaction == `heart` ? ` reaction--active` : ``)}>
                        <button role="img" aria-label="heart" onClick={this.doReaction}>
                            <Emoji type="heart" />
                            <span>{ this.state.count.heart }</span>
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className={`reactions ${this.props.className || ''}`}>
                <div className={`reaction` + (this.state.choosenReaction == `heart` ? ` reaction--active` : ``)}>
                    <button role="img" aria-label="heart" onClick={this.doReaction}>
                        <Emoji type="heart" />
                        Älskar
                    </button>
                    <span>{ this.state.count.heart }</span>
                </div>
                <div className={`reaction` + (this.state.choosenReaction == `wow` ? ` reaction--active` : ``)}>
                    <button role="img" aria-label="wow" onClick={this.doReaction}>
                        <Emoji type="wow" />
                        Wow!
                    </button>
                    <span>{ this.state.count.wow }</span>
                </div>
                <div className={`reaction` + (this.state.choosenReaction == `sad` ? ` reaction--active` : ``)}>
                    <button role="img" aria-label="sad" onClick={this.doReaction}>
                        <Emoji type="sad" />
                        Ledsen
                    </button>
                    <span>{ this.state.count.sad }</span>
                </div>
                <div className={`reaction` + (this.state.choosenReaction == `happy` ? ` reaction--active` : ``)}>
                    <button role="img" aria-label="happy" onClick={this.doReaction}>
                        <Emoji type="happy" />
                        Kul!
                    </button>
                    <span>{ this.state.count.happy }</span>
                </div>
                <div className={`reaction` + (this.state.choosenReaction == `angry` ? ` reaction--active` : ``)}>
                    <button role="img" aria-label="angry" onClick={this.doReaction}>
                        <Emoji type="angry" />
                        Dumt!
                    </button>
                    <span>{ this.state.count.angry }</span>
                </div>
            </div>
        );
    }
}

export default Reactions;